import { TypeAndDescription } from './typeAndDescription'
import { CouponRules } from './couponRules'
import { CouponValidity } from './couponValidity'

import { Container } from './style'

export function CouponForms() {

    return(
        <Container>
            
            <TypeAndDescription />
        
            <CouponRules />
                
            <CouponValidity />

        </Container>
    )

}